import { render, staticRenderFns } from "./FeaturesSimiaBeck.vue?vue&type=template&id=ff0fc848&scoped=true&"
import script from "./FeaturesSimiaBeck.vue?vue&type=script&lang=js&"
export * from "./FeaturesSimiaBeck.vue?vue&type=script&lang=js&"
import style0 from "./FeaturesSimiaBeck.vue?vue&type=style&index=0&id=ff0fc848&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff0fc848",
  null
  
)

export default component.exports